import { Api } from "../config/request";

export default {
  getFeatureList(payload) {
    return Api.post("/feature/list", payload);
  },
  getFeature(payload) {
    return Api.post("/feature/detail", payload);
  },
  createFeature(payload) {
    return Api.post("/feature/upsert", payload);
  },
  deleteFeature(payload) {
    return Api.post("/feature/delete", payload);
  },
};
